module.exports = __webpack_public_path__ + "img/barraFondoMobile.ffdc0d9c.svg";